<template>
  <div v-if="model!==null">
    <div class="content-area__content" v-if="isMFAChallenge">
      <mfa-challenge-component :mfaChallenge="model" />
    </div>
    <div v-else>
      <verify-phone-component :submitVerificationCode="oobaChallenge" resendLink="authentication/sendverificationcodechallenge" />
    </div>
  </div>
</template>

<style>
</style>

<script>
  import validation from 'utils/validation-mixin';
  import redirectHandler from 'utils/redirect';
  import Vue from 'vue';
  import $ from 'jquery';
  import verifyphone from './verify-phone';
  import mfaChallenge from './mfa-challenge';

  Vue.component('verify-phone-component', verifyphone);
  Vue.component('mfa-challenge-component', mfaChallenge);

  export default {
    mixins: [
      validation
    ],

    data() {
      return {
        oobaChallenge: {
          action: 'authentication/challenge',
          isOOBARegistration: false,
          challengeModel: null
        },
        model: null,
        isMFAChallenge: true
      };
    },

    async created() {
      try {
        let response = await this.$http.get('authentication/challenge');
        this.model = response;
        this.oobaChallenge.challengeModel = response;
        this.isMFAChallenge = response.data.isMFAChallenge
      } catch (error) {
        let form = this.$refs.form;
        if (this.validateResponse(form, error.response)) {
          return;
        }
        throw error;
      }
    }
  };
</script>
